import { Text } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const MetadataErrorMessage = styled(Text).attrs({ variant: 'small', color: 'subtle' })`
  margin-top: ${({ theme }) => theme.size.space['03']};
`

export const StorageContentList = styled.div<{ $displayBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['03']};
  border: ${({ $displayBorder, theme }) => $displayBorder && `1px solid ${theme.color.border.subtle}`};
  border-radius: ${({ $displayBorder, theme }) => $displayBorder && theme.size.border.radius['04']};
  padding: ${({ $displayBorder, theme }) => $displayBorder && theme.size.space['04']};
`
